"use client";

import React from "react";
import { ArrowRight, Image as ImageIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function ProductCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="flex gap-4 overflow-hidden">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="min-w-[280px] h-[380px] bg-muted/50 animate-pulse rounded-md" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground bg-muted/20 rounded-md border border-border/50">
        Şu anda görüntülenecek ürün bulunmamaktadır.
      </div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: false
  }} className="w-full">
      <CarouselContent className="-ml-4 md:-ml-6">
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="pl-4 md:pl-6 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
            <Card className="h-full border-border/60 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden group bg-card flex flex-col rounded-md">
              <Link to={product.link} className="block aspect-[4/3] overflow-hidden bg-muted relative">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center text-muted-foreground/30">
                    <ImageIcon className="w-10 h-10" />
                  </div>}
                <div className="absolute top-3 left-3 bg-primary/90 text-primary-foreground text-[10px] font-mono px-2 py-1 rounded-sm tracking-wider uppercase">
                  Made in Germany
                </div>
              </Link>
              <CardContent className="p-5 flex flex-col flex-grow gap-3">
                <div className="flex justify-between items-start gap-2">
                  <Link to={product.link}>
                    <h3 className="font-default font-bold text-lg text-foreground line-clamp-2 hover:text-primary transition-colors uppercase tracking-tight">
                      {product.title}
                    </h3>
                  </Link>
                </div>
                <div className="mt-auto flex items-end justify-between pt-4">
                  <div className="flex flex-col">
                    <span className="text-[10px] font-mono text-muted-foreground uppercase">Endüstriyel Çözüm</span>
                    <span className="font-default text-xl font-bold text-foreground tracking-tighter">
                      Teklif Al
                    </span>
                  </div>
                  <Link to="/GetOfferPage" className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-4 h-10 flex items-center justify-center shadow-md text-xs font-bold transition-transform active:scale-95 uppercase tracking-widest">
                    TEKLİF
                  </Link>
                </div>
              </CardContent>
            </Card>
          </CarouselItem>)}
      </CarouselContent>
      <div className="flex justify-end gap-3 mt-8">
        <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background border-border/60 hover:bg-primary hover:text-primary-foreground size-10 rounded-md transition-colors" />
        <CarouselNext className="static translate-y-0 translate-x-0 bg-background border-border/60 hover:bg-primary hover:text-primary-foreground size-10 rounded-md transition-colors" />
      </div>
    </Carousel>;
}
export default function RecienSalidoDelHorno() {
  const wp_query_params = {
    per_page: 8,
    orderby: "date",
    order: "desc",
    post_type: "product"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223624" id="öne-çıkan-çözümler" className="w-full py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-12 gap-4 border-l-4 border-primary pl-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tighter uppercase">
              Öne Çıkan Çözümler
            </h2>
            <p className="mt-3 text-muted-foreground text-lg max-w-md font-default leading-relaxed">
              Butzbach GMBH mühendisliği ile üretilen, yüksek performanslı endüstriyel kapı sistemlerimizi keşfedin.
            </p>
          </div>
          <Link to="/ShopPage" className="text-primary hover:text-primary/80 font-bold inline-flex items-center gap-1.5 transition-colors pb-1 sm:pb-2 whitespace-nowrap uppercase text-sm tracking-widest">
            TÜM KATALOĞU İNCELE <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 8,
        orderby: "date",
        order: "desc",
        post_type: "product"
      }}>
          <ProductCarouselConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}